import React from 'react';
import BrandDetailProductSummary from '../BrandDetailProductSummary';
import BrandDetailProductList from '../BrandDetailProductList';
import { useBrandDetailProduct } from '../../../../../hooks/brand/detail/useBrandDetailProduct';

const BrandDetailProductSection = ({ storeId }) => {
  const {
    brandDetailProductInfo,
    getBrandDetailProduct,
    getProductSubCategoryList,
    getBrandDetailProductExcelDownload,
  } = useBrandDetailProduct(storeId);
  const { summaryInfo, listInfo } = brandDetailProductInfo;

  return (
    <div className="brand-detail-product-section">
      {/*상품 취합 정보*/}
      <BrandDetailProductSummary summaryInfo={summaryInfo} />

      {/*상품 리스트*/}
      <BrandDetailProductList
        listInfo={listInfo}
        getList={getBrandDetailProduct}
        getProductSubCategoryList={getProductSubCategoryList}
        getBrandDetailProductExcelDownload={getBrandDetailProductExcelDownload}
      />
    </div>
  );
};

export default BrandDetailProductSection;
